import { render, staticRenderFns } from "./goods-select.vue?vue&type=template&id=c5af8ee8"
import script from "./goods-select.vue?vue&type=script&lang=js"
export * from "./goods-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports